import { render, staticRenderFns } from "./InvoicePage.vue?vue&type=template&id=6961e2a7&scoped=true&"
import script from "./InvoicePage.vue?vue&type=script&lang=ts&"
export * from "./InvoicePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6961e2a7",
  null
  
)

export default component.exports